// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task[data-v-dcd7e996]{width:100%;background:#fff;border-radius:.2rem;margin-top:.2rem;margin-bottom:.2rem;overflow:hidden}.task>div[data-v-dcd7e996]{margin:0 .3rem;width:auto}.task .task-title[data-v-dcd7e996]{height:.8rem;font-size:.32rem;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:#333;line-height:.8rem}.task .task-line[data-v-dcd7e996]{height:.02rem;background:#ebebeb}", ""]);
// Exports
module.exports = exports;
